import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService, IAuthService } from "../../../auth/auth.service";
import { from, map, mergeMap, switchMap, tap } from "rxjs";

export const autoAuthInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next:
  HttpHandlerFn) => {

  const authService: IAuthService = inject(AuthService);

  return from(authService.doAutoAuth()).pipe(
      switchMap(cleaned_auth_token => {
        if (cleaned_auth_token) {
          const modifiedReq = req.clone({
            headers: req.headers.set('X-Auth-Token', cleaned_auth_token),
          });
          return next(modifiedReq);
        }

        return next(req);
      })
  )
};